module.exports = __webpack_public_path__ + "static/media/plus.ea3149c4.svg";